/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, Fragment } from "react";
import Cookies from "js-cookie";
import ServiceApi from "../services/ServiceApi";
// import Api from "../services/ServiceApi";

const LayoutMaxi = (props) => {
  const { children } = props;
  const logoutClicked = () => {
    Cookies.remove("OperationToken");
    Cookies.remove("MaxiToken");
    window.location.assign(ServiceApi.absoluteUrl("/login"));
  };

  useEffect(() => {
    if (!Cookies.get("OperationToken") && !Cookies.get("MaxiToken")) {
      logoutClicked();
    }
    return () => {};
  }, []);
  return (
    <Fragment>
      <nav
        className="navbar navbar-expand-lg navbar-light position-fixed"
        style={{ height: "60px", zIndex: 2000 }}
      >
        <a
          className="navbar-brand"
          href={ServiceApi.absoluteUrl("/SelectModules")}
        >
          <img
            src={ServiceApi.absoluteUrl("/logo/maxitask.svg")}
            width="160"
            alt=""
          />
        </a>
        <ul className="navbar-nav"></ul>
        <ul className="navbar-nav ml-auto">
          <li className="nav-item dropdown border-left">
            <a
              className="h-100 d-flex align-items-center nav-link dropdown-toggle"
              id="navbarDropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="font-mont-m fs-14">
                {Cookies.get("username")}
              </span>
            </a>
            <div
              className="dropdown-menu"
              aria-labelledby="navbarDropdownMenuLink"
            >
              <a className="dropdown-item" onClick={logoutClicked}>
                Logout
              </a>
            </div>
          </li>
        </ul>
      </nav>

      {children}
    </Fragment>
  );
};

export default LayoutMaxi;
